import React from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import moment from "moment";
import { useLocaleData } from "../../i18n/useT";

const Header = () => {
  const data = useLocaleData("header") || {};
  const tooltips = data.tooltips || {};
  const countAge = () => {
    const birthYear = moment("1995-09-19").year();
    const age = moment().year() - birthYear;
    // check if the birthday passed
    if (moment().dayOfYear() < moment("1995-09-19").dayOfYear()) return age - 1;

    return age;
  };
  return (
    <section className="p-3 p-lg-5 d-sm-flex d-md-flex-inline" id="about">
      <div className="row">
        <div className="col-sm-4">
          <div className="text-center">
            <div>
              <img
                src="/resume/assets/images/passport.jpg"
                className="img-fluid img-thumbnail mb-3"
                alt=""
              />
            </div>
            <h3 className="text-uppercase">{data.displayName}</h3>
            <h4
              data-tooltip-id="my-tooltip"
              data-tooltip-content={`${countAge()} ${data.ageSuffix}`}
            >
              1995.09.19
            </h4>
          </div>
        </div>
        <div className="col-sm-8">
          <div className="d-md-inline">
            <h1 className="text-center display-4">
              <strong>{data.displayNameUpper}</strong>
            </h1>
            <div className="text-uppercase mb-3">
              <h3>
                <small>
                  {data.contact}{" "}
                  <a
                    href="mailto:vova.e.125@gmail.com"
                    className="tooltip-element"
                    data-tooltip-content={data.emailTooltip}
                  >
                    vova.e.125@gmail.com
                  </a>
                </small>
              </h3>
            </div>
            <div className="text-secondary text-justify">{data.bio}</div>
            <div className="d-flex d-inline align-items-end">
              <div className="mr-3">
                <a
                  href="https://www.linkedin.com/in/vladimir-egay/"
                  rel="noopener noreferrer"
                  target="_blank"
                  className="icon-style mr-2 tooltip-element"
                  data-tooltip-content={tooltips.linkedin}
                >
                  <i className="fa fa-linkedin" aria-hidden="true"></i>
                </a>
                <a
                  href="https://github.com/Vladimir-125"
                  rel="noopener noreferrer"
                  target="_blank"
                  className="icon-style mr-2 tooltip-element"
                  data-tooltip-content={tooltips.github}
                >
                  <i className="fa fa-github" aria-hidden="true"></i>
                </a>
                <a
                  href="https://www.facebook.com/vladimir.egay.official"
                  rel="noopener noreferrer"
                  target="_blank"
                  className="icon-style mr-2 tooltip-element"
                  data-tooltip-content={tooltips.facebook}
                >
                  <i className="fa fa-facebook-official"></i>
                </a>
              </div>
              <div className="mb-2">
                <a
                  href="/resume/assets/data/Vladimir_Egay_en.pdf"
                  className="download-icon-style mr-2 tooltip-element"
                  data-tooltip-content={tooltips.downloadCv}
                >
                  <span>{data.downloadCv}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ReactTooltip anchorSelect=".tooltip-element" />
    </section>
  );
};

export default Header;
